// extracted by mini-css-extract-plugin
module.exports = {"csr-D":"D_csr-D__lNskc"};